import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 1280px) {
    max-width: 1220px;
  }
  @media (max-width: 575.98px) {
    padding: 0px 30px;
  }

  .row {
    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;

      position: relative;
      width: 100%;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
    }
  }
`;

export const Facilitiescard = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  @media (max-width: 575.98px) {
    padding: 0px !important;
  }
  .card-wrapper {
    padding: 30px;
    background: #fff;
    text-align: center;
    position: relative;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 576px) {
    flex: 0 0 50%;
    max-width: 50%;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 992px) {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .accordion-item {
    &.collapsed {
      pointer-events: none;
      .card-details {
        opacity: 0;
      }
    }
    .card-details {
      opacity: 1;
    }
  }
`;

export const CardDescprt = styled.div``;

export const Titleh3 = styled.h3`
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,serif!important' : '')};

  @media (max-width: 767px) {
    font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
  }
`;

export const CardLogo = styled.div`
  width: 147px;
  height: 98px;
  max-height: none;
  overflow: hidden;
  position: relative;
  padding: 0;
  margin: 0 auto 20px;
  z-index: 1;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    max-width: none;
    transform: translate(-50%, -50%);
  }
`;

export const Descplwr = styled.div`
  font-size: 10px;

  p {
    margin-bottom: 1.5rem;
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0px' : '1.29px')};
  }

  a {
    font-size: 12px;
    text-decoration: underline;
    text-transform: uppercase;
  }
  .time_day {
    text-transform: uppercase;
  }

  a:hover {
    color: #1b7bdd;
  }
`;

export const InfoDetails = styled.div`
  transition: 0.5s;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
  background: #ebebeb;
  overflow: hidden;
  z-index: 2;
  opacity: 1;

  &.accordion-item {
    overflow: hidden;
  }

  &.accordion-item.collapsed {
    opacity: 0;
  }

  &.postn_inherit {
    position: inherit;
  }
`;

export const InfoDetailsPart = styled.div`
  @media (min-width: 768px) {
    padding: 50px 30px 30px;
  }

  @media (max-width: 767px) {
    padding: 20px;
  }
  @media (max-width: 575.98px) {
    padding: 50px 30px 30px;
  }
  p {
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0px' : '1.29px')};
    margin-bottom: 1.5rem;
  }
`;

export const ToggleTag = styled.a`
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: 25px;
  width: 25px;
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  border-radius: 100%;
  border: 2px solid #4a4a4a;
  position: absolute;
  top: 10px;
  right: ${({ dir }) => (dir === 'rtl' ? '' : '10px')};
  left: ${({ dir }) => (dir === 'rtl' ? '10px' : '')};
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINBold ')};
  color: #4a4a4a;
  z-index: 3;
  cursor: pointer;

  &.accordion-title {
    border: 2px solid #4a4a4a;
    border-radius: 1.5em;
    display: flex;
    justify-content: ${({ dir }) => (dir === 'rtl' ? 'center' : 'space-between')};
    align-items: center;

    &:after {
      content: 'i';
    }

    &[dir='rtl'] {
      &:after {
        position: relative;
        top: 2px;
      }

      &.open {
        &:after {
          top: 0;
        }
      }
    }

    &:hover,
    &.open {
      color: black;
    }

    &.open {
      padding-top: 0;
      line-height: 16px;

      &:after {
        content: 'x';
      }
    }
  }
`;

export const CardFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FacilitiesHead = styled.div`
  width: 23%;
  margin: 0.75rem 1%;
  position: relative;

  @media (max-width: 1200px) {
    width: 31%;
  }

  @media (max-width: 992px) {
    width: 48%;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`;
